import React from "react";
import { Modal, Button } from "antd";
import FormEmployee from "../formEmployee/formEmployee";

const ModalEmployee = ({
    visible,
    onClose,
    states,
    setters,
    newEmployee,
    editEmployee,
    createEmployee
}) => {
    return (
        <Modal
            title={newEmployee ? "Crear nuevo colaborador" : "Editar colaborador"}
            open={visible}
            onCancel={onClose}
            footer={null}
            width="80%"
        >
            <FormEmployee
                {...states}
                {...setters}
                newEmployee={newEmployee}
                editEmployee={editEmployee}
                createEmployee={createEmployee}
            />
        </Modal>
    );
};

export default ModalEmployee;
